<div class="ts1-rating-ob-panel" [class.ts1-rating-ob-panel--bulk-toggling]="bulkToggling">
	<mat-accordion [multi]="true" class="ob-selection-accordion">
		@for (OB of TS1_OB_LIST; track OB.title) {
			<mat-expansion-panel
				class="mat-elevation-z0 ts1-ob-section"
				[expanded]="isSectionExpanded(OB.title)"
				(expandedChange)="onSectionExpandedChange(OB.title, $event)"
			>
				<mat-expansion-panel-header class="ts1-ob-section-header">
					<mat-panel-title>
						<div class="flex w-full items-center gap-2">
							<div
								class="block size-2 shrink-0 self-center rounded-full"
								[class.bg-violet]="hasSectionValue(OB.title)"
								[class.bg-grey-40]="!hasSectionValue(OB.title)"
							></div>
							<span class="font-bold">{{ OB.name }}</span>
						</div>
					</mat-panel-title>
				</mat-expansion-panel-header>

				@for (item of OB.item_desc; track $index; let i = $index) {
					@let obLabel = getObLabel(OB.title, i);
					@let leftCtrl = getObControl(leftManeuverForm, OB.title, i, leftSlot);
					@let rightCtrl = getObControl(rightManeuverForm, OB.title, i, rightSlot);
					<div class="ts1-ob-row grid grid-cols-2 border-b border-grey-10">
						<ng-container
							*ngTemplateOutlet="
								obCell;
								context: {
									side: 'left',
									form: leftManeuverForm,
									control: leftCtrl,
									obLabel: obLabel,
									role: leftCandidateRole,
									columnEnabled: leftColumnEnabled,
									description: item.description,
									borderRight: true,
								}
							"
						></ng-container>
						<ng-container
							*ngTemplateOutlet="
								obCell;
								context: {
									side: 'right',
									form: rightManeuverForm,
									control: rightCtrl,
									obLabel: obLabel,
									role: rightCandidateRole,
									columnEnabled: rightColumnEnabled,
									description: item.description,
									borderRight: false,
								}
							"
						></ng-container>
					</div>
				}
			</mat-expansion-panel>
		}
	</mat-accordion>
</div>

<ng-template
	#obCell
	let-side="side"
	let-form="form"
	let-control="control"
	let-obLabel="obLabel"
	let-role="role"
	let-columnEnabled="columnEnabled"
	let-description="description"
	let-borderRight="borderRight"
>
	@let actionMode = isActionMode(form, obLabel, side);
	@let obValue = getObValue(control);
	@let actionsMuted = isActionsMuted(form, obLabel, side, control, role);
	@let dragging = isDragging(form, obLabel, side);
	<div
		class="ts1-ob-cell"
		[class.border-r]="borderRight"
		[class.border-grey-20]="borderRight"
		[ngClass]="cellStateClass(control, columnEnabled, form, obLabel, role, side)"
		(pointerdown)="onCellPointerDown($event, form, control, obLabel, role, columnEnabled, side)"
		(pointermove)="onCellPointerMove($event, form, control, obLabel, role, side)"
		(pointerup)="onCellPointerUp($event, form, control, obLabel, role, columnEnabled, side)"
		(pointerleave)="onCellPointerCancel(form, obLabel, side, control, role)"
		(pointercancel)="onCellPointerCancel(form, obLabel, side, control, role)"
		(contextmenu)="onCellContextMenu($event, form, control, obLabel, role, columnEnabled, side)"
	>
		<div class="ts1-ob-cell__label flex min-w-0 flex-1 items-center gap-2">
			<div class="ts1-ob-dot size-2 shrink-0 rounded-full" aria-hidden="true"></div>
			<mat-icon
				class="ts1-ob-info !h-4 !w-4 shrink-0 text-sm text-grey-40"
				[matTooltip]="description"
				matTooltipPosition="above"
				>info</mat-icon
			>
			<span class="truncate text-base font-bold leading-none lg:text-lg">{{ obLabel }}</span>
			@if (columnEnabled && (obValue.currentCount > 0 || obValue.totalCount > 0)) {
				<span class="ob-attempt shrink-0 text-xs lg:text-sm"
					>[{{ obValue.currentCount }}/{{ obValue.totalCount }}]</span
				>
			}
		</div>

		@if (columnEnabled) {
			@let predefinedStarTick = predefinedStarRevision;
			@let showPredefinedStar = shouldShowPredefinedStar(form, control, obLabel, role);
			@let showConditionalBadge = shouldHighlightConditionalOb(form, control, obLabel, role);
			<div
				class="ts1-ob-actions"
				[class.ts1-ob-actions--revealed]="actionMode || actionsMuted"
			>
				<div
					class="ts1-ob-actions__primary"
				>
					@if (showPredefinedStar) {
						<img
							class="ts1-ob-star shrink-0"
							src="/assets/predefined_stars_teal.svg"
							width="24"
							height="24"
							alt=""
							role="img"
							[attr.aria-label]="predefinedObBadgeTooltip"
							[attr.data-star-rev]="predefinedStarTick"
							[matTooltip]="predefinedObBadgeTooltip"
							matTooltipPosition="above"
						/>
					}
					@if (showConditionalBadge) {
						<img
							class="ts1-ob-star shrink-0"
							[src]="conditionalObBadgeSrc"
							width="24"
							height="24"
							alt=""
							role="img"
							[attr.aria-label]="conditionalObBadgeTooltip"
							[matTooltip]="conditionalObBadgeTooltip"
							matTooltipPosition="above"
						/>
					}
					<button
						type="button"
						class="attemptBtn removeBtn flex h-8 w-8 items-center justify-center rounded-lg text-base lg:h-9 lg:w-9 lg:text-lg"
						[class.opacity-50]="shouldDisableRemove(control, columnEnabled, form, obLabel, side, role)"
						[disabled]="shouldDisableRemove(control, columnEnabled, form, obLabel, side, role)"
						(click)="onRemove(form, control, obLabel, role, columnEnabled, side)"
						(pointerdown)="$event.stopPropagation()"
						(contextmenu)="$event.stopPropagation()"
					>
						-
					</button>
					<button
						type="button"
						class="attemptBtn addBtn flex h-8 w-8 items-center justify-center rounded-lg text-base lg:h-9 lg:w-9 lg:text-lg"
						[class.opacity-50]="shouldDisableAdd(control, columnEnabled, form, obLabel, side, role)"
						[disabled]="shouldDisableAdd(control, columnEnabled, form, obLabel, side, role)"
						(click)="onAdd(form, control, obLabel, role, columnEnabled, side)"
						(pointerdown)="$event.stopPropagation()"
						(contextmenu)="$event.stopPropagation()"
					>
						+
					</button>
				</div>

				<div
					class="ts1-ob-actions__reveal"
					[class.ts1-ob-actions__reveal--dragging]="dragging"
					[style.width.px]="getRevealVisibleWidth(form, obLabel, side, control, role)"
					[attr.aria-hidden]="!(actionMode || actionsMuted)"
				>
					@if (showPredefinedStar) {
						<button
							type="button"
							class="actionBtn actionBtn--na"
							(click)="onNA(form, control, obLabel, role, columnEnabled, side)"
							(pointerdown)="$event.stopPropagation()"
							(contextmenu)="$event.stopPropagation()"
							[matTooltip]="isGreyed(control, side) ? 'Enable OB' : 'Mark as N/A'"
						>
							<mat-icon>{{ isGreyed(control, side) ? "check_circle" : "remove_circle_outline" }}</mat-icon>
						</button>
					}
					@if (shouldShowObservationComment(form, control, obLabel, role)) {
						<button
							type="button"
							class="actionBtn actionBtn--comment"
							(click)="onObservationComment(form, control, obLabel, role, columnEnabled, side)"
							(pointerdown)="$event.stopPropagation()"
							(contextmenu)="$event.stopPropagation()"
							matTooltip="Comments"
						>
							<mat-icon>chat</mat-icon>
						</button>
					}
					@if (showUndo(form, obLabel, role)) {
						<button
							type="button"
							class="actionBtn actionBtn--undo"
							(click)="onUndo(form, control, obLabel, role, columnEnabled, side)"
							(pointerdown)="$event.stopPropagation()"
							(contextmenu)="$event.stopPropagation()"
							matTooltip="Undo last change"
						>
							<mat-icon>restart_alt</mat-icon>
						</button>
					}
				</div>
			</div>
		}
	</div>
</ng-template>
